import {useEffect} from "react";
import {useTitle} from "../../contexts/title";

export default function NotFoundPage() {

	const pageTitle = useTitle();
	useEffect(() => {
		pageTitle.setTitle('Page Not Found')
	}, [pageTitle]);

	return (<>
		<div className={'content-block'}>
			<h2>Page Not Found</h2>
		</div>
	</>)
}
